module.exports = __webpack_public_path__ + "img/left-bottom-shape.0bfa6b14.svg";